import { RegisterPage } from '@agentic-flow-studio/shared/components/auth/RegisterPage';
import { Truck } from 'lucide-react';
import { authClient } from '../utils/betterAuth';

export default function Register() {
  return (
    <RegisterPage
      brandName="Job Plan"
      logo={
        <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center text-primary-foreground">
          <Truck className="h-5 w-5" />
        </div>
      }
      app="job-plan"
      authClient={authClient}
    />
  );
}
